import styled from 'styled-components'

export const Container = styled.div`
    display: block;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: auto;
    align-self: stretch;
`
